function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 0H22C28.6274 0 34 5.37258 34 12V12C34 18.6274 28.6274 24 22 24H0V0Z",
  fill: "#3ECF8E"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M25 8V16",
  stroke: "#fff",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17 16L21 12L17 8",
  stroke: "#fff",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 24,
    viewBox: "0 0 34 24",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/menu-open.81448b25.svg";
export { SvgComponent as ReactComponent };